import React from 'react';
import '../assets/css/Totd.css'; // Import the CSS file for styling

const Terms = () => {
  return (
    <div className="container">
      <section className="ctext section-body" id="header1-0" data-rv-view="0">
        <div className="filter-container">
        <div className="container">
          <div className="row">
            <div className="totdText">
              <h3>RippaDay Terms of Use</h3>
              <p><strong>Last updated: 14 July 2026</strong></p>
              <p>By using rippaday.com, the RippaDay mobile apps, or any RippaDay content, you agree to these Terms of Use.</p>

              <h4>Information only</h4>
              <p>RippaDay provides racing information, tips, tools, and related content for entertainment and informational purposes only. RippaDay is not a bookmaker, betting operator, financial adviser, or gambling service. We do not take bets or guarantee any outcome, return, profit, or result.</p>

              <h4>Responsible use</h4>
              <p>You are responsible for complying with the laws that apply where you live or use RippaDay. Do not use RippaDay if you are under the legal age for racing or betting-related information in your location. Gamble responsibly. If gambling is causing harm, contact a local support service such as <a href="https://www.gamblinghelponline.org.au/">Gambling Help Online</a>.</p>

              <h4>Accounts and subscriptions</h4>
              <p>You must provide accurate account information and keep your sign-in details secure. Some RippaDay features may require a paid subscription. Subscription terms, billing, cancellation, refunds, and renewals may be managed by the platform or payment provider used for purchase, including Apple, Google, Stripe, or another provider shown at checkout.</p>
              <p>Deleting your RippaDay account does not automatically cancel an active subscription with an app store or payment provider. You should cancel subscriptions through the provider that bills you, or contact support if you need help.</p>

              <h4>Acceptable use</h4>
              <p>You must not copy, scrape, resell, redistribute, reverse engineer, interfere with, or misuse RippaDay content, data, systems, or accounts without written permission. We may suspend or restrict access where needed to protect the service or enforce these terms.</p>

              <h4>Content accuracy</h4>
              <p>Racing data, odds, tips, and other information can change without notice and may contain errors or delays. You use the information at your own risk.</p>

              <h4>Privacy and account deletion</h4>
              <p>Our <a href="/privacy/">Privacy Policy</a> explains how we handle personal information. Account deletion information is available at <a href="/account-deletion/">rippaday.com/account-deletion/</a>.</p>

              <h4>Contact</h4>
              <p>For support, email <a href="mailto:support@rippaday.com">support@rippaday.com</a>.</p>
            </div>
          </div>
        </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
